var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,9.75A3.75,3.75,0,1,1,9.75,6,3.75,3.75,0,0,1,13.5,9.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,18.75A3.75,3.75,0,1,1,9.75,15,3.75,3.75,0,0,1,13.5,18.75Z",
    transform: "translate(0 2.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75,31.5A3.75,3.75,0,1,0,6,27.75,3.75,3.75,0,0,0,9.75,31.5Z",
    transform: "translate(0 4.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,9.75A3.75,3.75,0,1,1,18.75,6,3.75,3.75,0,0,1,22.5,9.75Z",
    transform: "translate(2.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75,22.5A3.75,3.75,0,1,0,15,18.75,3.75,3.75,0,0,0,18.75,22.5Z",
    transform: "translate(2.25 2.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,27.75A3.75,3.75,0,1,1,18.75,24,3.75,3.75,0,0,1,22.5,27.75Z",
    transform: "translate(2.25 4.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.75,13.5A3.75,3.75,0,1,0,24,9.75,3.75,3.75,0,0,0,27.75,13.5Z",
    transform: "translate(4.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18.75A3.75,3.75,0,1,1,27.75,15,3.75,3.75,0,0,1,31.5,18.75Z",
    transform: "translate(4.5 2.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.75,31.5A3.75,3.75,0,1,0,24,27.75,3.75,3.75,0,0,0,27.75,31.5Z",
    transform: "translate(4.5 4.5)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.0f45ea9e77e8143e4f61362366bc8824.svg";
export { ForwardRef as ReactComponent };